import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, BriefcaseIcon } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-32 px-6 bg-slate-900" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-65">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-66">
            ¿Avanzamos?
          </h2>
          <p className="text-xl text-slate-300 mb-12" data-id="element-67">
            Elegí tu camino y comencemos a trabajar juntos
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-68">
          <div className="text-center" data-id="element-69">
            <p className="text-white/90 font-medium mb-3" data-id="element-70">Para empresas</p>
            <a href="#contacto" className="group inline-flex items-center justify-center px-8 py-4 bg-emerald-500 text-white font-semibold rounded-lg hover:bg-emerald-600 transition-all duration-300 hover:scale-105" data-id="element-71">
              Quiero conversar
              <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-72" />
            </a>
            <p className="text-sm text-slate-400 mt-3" data-id="element-73">
              Sin compromiso. Elegí canal y horario.
            </p>
          </div>

          <div className="hidden sm:block w-px h-24 bg-white/10" data-id="element-74"></div>

          <div className="text-center" data-id="element-75">
            <p className="text-white/90 font-medium mb-3" data-id="element-76">Para candidatos</p>
            <a href="#empleo" className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border-2 border-white/20 hover:bg-white/20 transition-all duration-300" data-id="element-77">
              <BriefcaseIcon className="mr-2 w-5 h-5" data-id="element-78" />
              Busco empleo
            </a>
            <p className="text-sm text-slate-400 mt-3" data-id="element-79">
              Completá el formulario
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}